import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import styles from './styles/SiteFooter.module.css';

const SiteFooter: React.FC = () => {
  const { pathname } = useLocation();
  if (pathname.startsWith('/admin') || pathname === '/login') return null;

  return (
    <footer className={styles.footer}>
      <div className={styles.inner}>
        <div className={styles.brand}>
          <img src="/logo.png" alt="Familia García Vidal" width="64" height="64" loading="lazy" />
          <div>
            <strong>Familia García Vidal</strong>
            <span>Del campo a tu mesa.</span>
          </div>
        </div>

        <nav className={styles.links} aria-label="Navegación del pie de página">
          <Link to="/productos">Productos</Link>
          <Link to="/envios">Envíos</Link>
          <Link to="/locales">Locales</Link>
          <Link to="/nosotros">Nosotros</Link>
          <Link to="/familia">Cliente fiel</Link>
        </nav>
      </div>
      <div className={styles.legal}>© {new Date().getFullYear()} Familia García Vidal</div>
    </footer>
  );
};

export default SiteFooter;
